var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box-card",style:({width:_vm.cardWidth}),attrs:{"shadow":"hover"}},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"cardTitle"},[_vm._v(_vm._s(_vm.cardName))]),_vm._t("right")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }